import { render, staticRenderFns } from "./BCKZUZGG.vue?vue&type=template&id=3b8818ac&scoped=true&"
import script from "./BCKZUZGG.vue?vue&type=script&lang=js&"
export * from "./BCKZUZGG.vue?vue&type=script&lang=js&"
import style0 from "./BCKZUZGG.vue?vue&type=style&index=0&id=3b8818ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8818ac",
  null
  
)

export default component.exports